import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EditArt } from 'src/app/_interfaces/EditArt';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { SaveService } from 'src/app/_provider/save.service';
import { TicketEditService } from 'src/app/_provider/ticket-edit.service';
import { PopoverPage } from 'src/app/_template/popover/popover.page';

@Component({
  selector: 'app-ticket-art-edit',
  templateUrl: './ticket-art-edit.page.html',
  styleUrls: ['./ticket-art-edit.page.scss', "../../setting-main.scss"],
})
export class TicketArtEditPage implements OnInit {

  public isNew: boolean = false
  public currentArt: EditArt

  public selectedMainArt: EditArt = {
    id: -1,
    description: "Keine Oberart"
  }

  public selectedToCalculate: EditArt = {
    id: 0,
    description: "Nicht Berechnen"
  }

  public intervall: number = null
  public description: string = ""

  constructor(
    private modalCtrl: ModalController,
    private ticketEditSrv: TicketEditService,
    private feedback: FeedbackService,
    private saveSrv: SaveService.Settings
  ) { 
    
  }
  
  ngOnInit() {
    if(!this.isNew){
      this.description = this.currentArt.description
      this.intervall = this.currentArt.interval
      this.selectedMainArt = this.ticketEditSrv.ticketArts.find(ta => ta.id == this.currentArt.parentId) || {
        id: -1,
        description: "Keine Oberart"
      }
      this.selectedToCalculate = this.ticketEditSrv.toCalculateList.find(ta => ta.id == this.currentArt.toCalculate) || null
    }
    
  }

  ngOnDestroy(){
    this.currentArt = undefined
  }

  public async back(){
    await this.modalCtrl.dismiss()
  }

  public async openMainArtPopover(event: any){
    await this.feedback.openPopover(PopoverPage, event, {type: "TicketArt"}, (result: HttpFunctionResult<EditArt>)=>{
      if(!result.success) return
      this.selectedMainArt = result.data
    })
  }

  public async openToCalculatePopover(event: any){
    await this.feedback.openPopover(PopoverPage, event, {type: "Calculate"}, (result: HttpFunctionResult<EditArt>)=>{
      if(!result.success) return
      this.selectedToCalculate = result.data
    })
  }

  public async deleteArt(){
    if(!(await this.feedback.confirm(`Möchten Sie die Ticketart "${this.currentArt.description}" wirklich löschen?`, "Löschen", "Abbrechen"))) return
    await this.feedback.updateLoading("Löschen...")
    const result: HttpFunctionResult<any> = await this.saveSrv.deleteTicketArt(this.currentArt.id)
    await this.feedback.hideLoading()
    if(!result.success) return
    this.ticketEditSrv.ticketArts.splice(this.ticketEditSrv.ticketArts.findIndex(ta=>ta.id == this.currentArt.id), 1)
    await this.modalCtrl.dismiss(this.currentArt)
  }

  public async save(){

    if(this.ticketEditSrv.ticketArts.find(ta => ta.description == this.description) && this.isNew) 
      return await this.feedback.showError("Die von Ihnen angegebene Bezeichnung existiert bereits. Bitte geben Sie eine andere Bezeichnung an.")

    if(!this.description) 
      return await this.feedback.showError("Bitte geben Sie eine Bezeichnung ein.")

    const ticketArt: EditArt = {
      description: this.description,
      id: this.isNew ? undefined : this.currentArt.id,
      parentId: this.selectedMainArt.id,
      type: 0,
      toCalculate: this.selectedToCalculate.id,
      interval: this.intervall ? this.intervall : 1
    }
    await this.feedback.updateLoading("Speichern...")
    let result: HttpFunctionResult<EditArt> 
    if(this.isNew) result = await this.saveSrv.createTicketArt(ticketArt)
    else result = await this.saveSrv.updateTicketArt(ticketArt)
    await this.feedback.hideLoading()
    if(!result.success) return

    if(this.isNew) this.ticketEditSrv.ticketArts.push(result.data)
    else{
      let art = this.ticketEditSrv.ticketArts.find(ta => ta.id == this.currentArt.id)
      art.description = this.description
      art.interval = !this.intervall ? 1 : this.intervall
      art.parentId = this.selectedMainArt.id
      art.toCalculate = this.selectedToCalculate.id
    }
    await this.modalCtrl.dismiss(result.data)

  }

}
